// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"0d40edd0","454":"a29003ba","642":"160861c4","751":"4928e669","784":"71cd507a","787":"81c95090"}[chunkId] + ".chunk.js";
};